import Loadable from 'react-loadable';

import PleaseWait from '~/components/loaders/please-wait';

export default Loadable({
  loader: () => import(/* webpackChunkName: "swiss-re", webpackPrefetch: true */ './SwissRe'),
  loading: () => <PleaseWait />,
});
